import React from 'react';
import { useNotifications } from '../../context/NotificationProvider';
import { FaTimes, FaCheckCircle, FaIdCard, FaMoneyBillWave } from 'react-icons/fa';

const NotificationDrawer = () => {
    const { counts, isDrawerOpen, setIsDrawerOpen, jumpToTask } = useNotifications();

    if (!isDrawerOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            right: 0,
            width: '100%',
            height: '100%',
            zIndex: 9999,
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: 'rgba(0,0,0,0.4)',
            backdropFilter: 'blur(4px)',
            transition: 'opacity 0.3s ease'
        }} onClick={() => setIsDrawerOpen(false)}>
            <div style={{
                width: '400px',
                height: '100%',
                backgroundColor: '#ffffff',
                boxShadow: '-10px 0 30px rgba(0,0,0,0.1)',
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                animation: 'slideLeft 0.3s ease-out',
                overflowY: 'auto'
            }} onClick={e => e.stopPropagation()}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '32px'
                }}>
                    <h2 style={{ fontSize: '24px', fontWeight: '700', color: '#1a1a1a', margin: 0 }}>Pending Tasks</h2>
                    <button 
                        onClick={() => setIsDrawerOpen(false)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#666', fontSize: '20px' }}>
                        <FaTimes />
                    </button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    <TaskGroup 
                        icon={<FaIdCard style={{ color: '#007bff' }} />}
                        title="Identity Verification" 
                        count={counts.identity} 
                        onClick={() => jumpToTask('identity')}
                    />
                    <TaskGroup 
                        icon={<FaCheckCircle style={{ color: '#28a745' }} />}
                        title="Badge Requests" 
                        count={counts.badge} 
                        onClick={() => jumpToTask('badge')}
                    />
                    <TaskGroup 
                        icon={<FaMoneyBillWave style={{ color: '#ffc107' }} />}
                        title="Withdrawal Requests" 
                        count={counts.withdrawal} 
                        onClick={() => jumpToTask('withdrawal')}
                    />
                </div>

                {Object.values(counts).every(c => c === 0) && (
                    <div style={{ 
                        marginTop: '60px', 
                        textAlign: 'center', 
                        color: '#999',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        gap: '16px'
                    }}>
                        <div style={{ fontSize: '48px' }}>🎉</div>
                        <p style={{ fontSize: '16px' }}>All caught up! No pending tasks.</p>
                    </div>
                )}
            </div>
            <style>{`
                @keyframes slideLeft {
                    from { transform: translateX(100%); }
                    to { transform: translateX(0); }
                }
            `}</style>
        </div>
    );
};

const TaskGroup = ({ icon, title, count, onClick }) => {
    return (
        <div 
            onClick={onClick}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '20px',
                borderRadius: '16px',
                backgroundColor: '#f8f9fa',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                border: '1px solid transparent'
            }}
            onMouseEnter={e => {
                e.currentTarget.style.backgroundColor = '#ffffff';
                e.currentTarget.style.borderColor = '#007bff';
                e.currentTarget.style.boxShadow = '0 10px 20px rgba(0,123,255,0.05)';
                e.currentTarget.style.transform = 'translateY(-2px)';
            }}
            onMouseLeave={e => {
                e.currentTarget.style.backgroundColor = '#f8f9fa';
                e.currentTarget.style.borderColor = 'transparent';
                e.currentTarget.style.boxShadow = 'none';
                e.currentTarget.style.transform = 'translateY(0)';
            }}
        >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <div style={{ 
                    fontSize: '20px', 
                    width: '40px', 
                    height: '40px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    backgroundColor: '#fff',
                    borderRadius: '10px',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.05)'
                }}>
                    {icon}
                </div>
                <span style={{ fontWeight: '600', color: '#1a1a1a', fontSize: '15px' }}>{title}</span>
            </div>
            {count > 0 && (
                <span style={{
                    backgroundColor: '#007bff',
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '20px',
                    fontSize: '13px',
                    fontWeight: '700'
                }}>
                    {count}
                </span>
            )}
        </div>
    );
}

export default NotificationDrawer;
